import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "fixed z-75 left-0 top-0 grid place-items-center w-screen h-screen"
};
var _hoisted_2 = { class: "relative z-10 flex items-center justify-between px-4 py-6 w-w32 text-white text-14px bg-white border border-dialog sm:w-contents-sm md:w-contents-md lg:w-contents" };
var _hoisted_3 = { class: "flex" };
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/assets/img/icon/exc_circle_red.svg",
    alt: "！"
}, null, -1);
var _hoisted_5 = { class: "mx-4 text-dialog" };
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/assets/img/icon/close_grey.svg",
    alt: "閉じる"
}, null, -1);
var _hoisted_7 = [
    _hoisted_6
];
import { useAcknowledgementStore } from '../../store';
import { storeToRefs } from "pinia";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AlertDialog',
    setup: function (__props) {
        var acknowledgementStore = useAcknowledgementStore();
        var dialog = storeToRefs(acknowledgementStore).dialog;
        var closeDialog = function () {
            if (dialog.value) {
                if (dialog.value.to) {
                    window.location.href = dialog.value.to;
                }
                acknowledgementStore.closeAcknowledgement(dialog.value.id);
            }
        };
        return function (_ctx, _cache) {
            var _a, _b;
            return (_unref(dialog) && ((_a = _unref(dialog)) === null || _a === void 0 ? void 0 : _a.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "absolute z-10 left-0 top-0 w-full h-full bg-black bg-opacity-50",
                        onClick: closeDialog
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("p", _hoisted_5, _toDisplayString((_b = _unref(dialog)) === null || _b === void 0 ? void 0 : _b.message), 1)
                        ]),
                        _createElementVNode("button", {
                            onClick: closeDialog,
                            class: "flex-shrink-0"
                        }, _hoisted_7)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
